/**
 * Chart Data Utilities — Shared normalization for Bar/Line/Pie chart renderers.
 *
 * Created s67: extracted from BarChartRenderer, LineChartRenderer, PieChartRenderer
 * to eliminate ~40 lines of duplicated data normalization code.
 */

export interface ChartDataPoint {
  label: string
  value: number
}

/**
 * Normalize chart data from seed config.
 * Supports two formats:
 * - Canonical: `{ data: [{ label, value }] }` or `{ data: [{ name, value }] }`
 * - Legacy: `{ labels: string[], values: number[] }`
 */
export function normalizeChartData(
  config: Record<string, unknown>,
): ChartDataPoint[] {
  const rawData = config.data
  if (Array.isArray(rawData) && rawData.length > 0) {
    return rawData.map(
      (d: { label?: string; name?: string; value?: number }) => ({
        label: d.label || d.name || '',
        value: d.value ?? 0,
      }),
    )
  }

  const labels = config.labels as string[] | undefined
  const values = config.values as number[] | undefined
  if (Array.isArray(labels) && Array.isArray(values)) {
    return labels.map((label, i) => ({
      label,
      value: values[i] ?? 0,
    }))
  }

  return []
}

/** Default color palette for pie/bar charts. */
export const CHART_COLORS = [
  '#6366f1',
  '#14b8a6',
  '#f59e0b',
  '#ec4899',
  '#8b5cf6',
  '#3b82f6',
  '#10b981',
  '#f43f5e',
] as const
